/**
 * https://stackoverflow.com/a/13500078/5663961
 */

/** */
const percentNotEscaping = /(?!%[0-9A-F]{2})%/g;

/**
 * A folder name goes into a <Link> path as it is, and the browser encodes the
 * characters a url cannot carry - except that `#` would start the fragment
 * and a bare `%` is a broken escape. Both are encoded here first.
 *
 * `%` becomes `%2525` and not `%25` because the router decodes the matched
 * `/*` segment once before handing it to useRoutePath: `%2525` comes back as
 * `%25`, which is the literal `%` in the form the drive APIs want (see
 * dbxDriveEncodeUri and oneDriveEncodeUri). `%23` comes back as `#`.
 *
 * @param uri
 */
export default function linkEncodeUri(uri?: string) {
  return uri?.replace(percentNotEscaping, '%2525').replace(/#/g, '%23');
}

/**
 * Dropbox want unencoded paths in requests
 * @param uri
 */
export function dbxDriveEncodeUri(uri: string) {
  return decodeURIComponent(
    // decodeURI doesn't want any stale % chars around
    // this regex finds all instances of % that are not html character escapings
    uri.replace(percentNotEscaping, '%25'),
  );
}
/**
 * Dropbox want unencoded paths in requests
 * @param uri
 */
export function oneDriveEncodeUri(uri: string) {
  // decodeURI doesn't want any stale % chars around
  // this regex finds all instances of % that are not html character escapings
  return uri.replace(percentNotEscaping, '%25');
}
